<template>
  <b-container>
    <h1>Roster</h1>
    <roster-calendar></roster-calendar>
  </b-container>
</template>
<script>
import RosterCalendar from './RosterCalendar';
export default {
  components: { RosterCalendar }
};
</script>
